import React from "react";
import Indusone from "../../images/STEEL PIPES AND OTHERS/1. VALVE/5.jpg";
// import Indusones from "../../images/STEEL PIPES AND OTHERS/1. VALVE/8.jpg";

function OurExpertise() {
  return (
    <div className="w-full">
      {/* Top Section - Image & Text */}
      <div className="mx-auto md:mt-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-1 md:mb-4 text-center">
            VALVES AND FLANGES
            </h2>
            <p className="text-sm md:text-lg mb-6 text-justify md:mt-2">
            AKT provides a wide range of manual valves and flanges for reliable control of fuel oil, water, gas, and air. Valves come with threaded or flanged connections (DN 6 to DN 250, up to 16 bar) in brass, steel, or ductile cast iron, meeting ISO 7005 standards. They are EC certified, low-torque, and easy to install. AKT also offers standard ASA/ANSI 150# flanges in various materials for high-pressure applications, ensuring durability and compatibility.
            </p>
          </div>
          {/* <div className="lg:col-span-5 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
          <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusones}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div> */}

          {/* Right Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertise;

